export class TimestampedComment {

  constructor(
    public readonly timestamp: number,
    public comment: string,
  ) {
  }
}
